// planIslemleri.js — PLAN: SİL — TEK KAYNAK (1 Eki 2026)
//
// 🔴 AKTİF ET / PASİF ET KALKTI (3 Kas 2026, Serkan: "web'de artık active deactive olmayacak, sadece available
//    planlar olacak"). Eskiden planiAktifEt şirketin TEK aktif planını belirliyordu (yenisi aktif edilince eskisi
//    Available'a dönerdi) ve bunu yapan pilotun ekip arkadaşı AYNI planı kendi cihazında AVAILABLE'da GÖREMİYORDU
//    (saha bulgusu: AAK, LTAC-LTAT/LTAT-LTAC paket uçuşunun 2. bacağını indiremedi — Serkan zaten aktive etmişti).
//    Aktivasyon artık YALNIZ iPad'de, yalnız cihazda (bkz. iOS `PlanPackageStore.markActive`) — sunucuya hiçbir şey
//    yazmaz. Plan sistemdeyken (arşivlenene kadar) HEP "available" kalır; kim işlediği bilgisi (bloklamayan, salt
//    bilgi) `flight_logs`'taki PLAN_ACTIVATED olaylarından gelir (bkz. AdminPanel `AvailablePlans`).
// 🔑 Serkan (1 Eki 2026, ofis talebi): web açılışı doğrudan admin panel, Dashboard kalkar, işlevleri FLT OPS'a.
// 🔴 ÖNCESİ: aktif/pasif etme hatası `catch {}` ile yutuluyordu. RLS'in engellediği güncelleme HATA DÖNMEZ, 0 satır
//    değiştirir (10 Ağu silme olayının dersi) — artık değişen satır geri istenir, değişmediyse SÖYLENİR.
import { supabase } from '../supabaseClient';

const IZIN_YOK = 'not permitted for this account, or the plan no longer exists. Nothing was changed.';

/** Planı siler — TEK silme, çocuk satırları CASCADE temizler. Dönüş: { hata } */
export async function planiSil(planId) {
  const { data, error } = await supabase.from('plans').delete().eq('id', planId).select('id');
  if (error) return { hata: `Plan could not be deleted: ${error.message}` };
  if (!data || !data.length) return { hata: `Plan could not be deleted: ${IZIN_YOK}` };
  return { hata: null };
}
